import Section from "./Section";

const TermsAndConditions = () => {
  return (
    <Section>
      <meta
        name="title"
        content="Terms and Conditions - User Agreement and Guidelines"
      />
      <meta
        name="description"
        content="Review our Terms and Conditions to understand the rules, guidelines, and obligations when using our services. Stay informed about your rights and responsibilities."
      />
      <meta
        name="keywords"
        content="terms and conditions, user agreement, service guidelines, website terms, user obligations, rules and regulations, legal terms"
      />
      <meta name="robots" content="index, follow" />
      <link
        rel="canonical"
        href="https://www.yourwebsite.com/terms-and-conditions"
      />
      <title>Terms and Conditions - User Agreement and Guidelines</title>
      <div className="container mx-auto overflow-hidden px-4 py-8 pt-[4.75rem] md:max-w-[70vw] lg:pt-[5.25rem]">
        <h1 className="mb-6 text-center text-3xl font-bold">
          Terms and Conditions
        </h1>

        <p className="mb-4 text-lg">
          Welcome to Bafar Labs! By using our services, you agree to the
          following Terms and Conditions. Please read them carefully.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">1. Introduction</h2>
        <p className="mb-4 text-lg">
          These Terms and Conditions govern your use of our website and
          services. By accessing or using our website, you agree to comply with
          these terms.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">2. Services</h2>
        <p className="mb-4 text-lg">
          Bafar Labs provides various software development, AI, and digital
          marketing services. We reserve the right to modify or discontinue any
          part of our services at any time without prior notice.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          3. User Responsibilities
        </h2>
        <p className="mb-4 text-lg">
          You agree to use our services in compliance with applicable laws and
          regulations. You also agree not to engage in any harmful activities
          such as hacking, spreading malware, or violating the rights of others.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          4. Account Registration
        </h2>
        <p className="mb-4 text-lg">
          To access certain features of our services, you may need to create an
          account. You are responsible for keeping your account information
          secure and for all activities under your account.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          5. Payment and Fees
        </h2>
        <p className="mb-4 text-lg">
          Some services may require payment. You agree to pay all fees and
          charges associated with the services you choose, in accordance with
          our pricing schedule.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          6. Intellectual Property
        </h2>
        <p className="mb-4 text-lg">
          All content, trademarks, and logos on our website are the property of
          Bafar Labs or our licensors. You may not use any of these materials
          without our express permission.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          7. Limitation of Liability
        </h2>
        <p className="mb-4 text-lg">
          Bafar Labs will not be liable for any direct, indirect, incidental,
          special, or consequential damages arising out of your use or inability
          to use our services, even if we have been advised of the possibility
          of such damages.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">8. Termination</h2>
        <p className="mb-4 text-lg">
          We reserve the right to suspend or terminate your access to our
          services at any time, for any reason, including violations of these
          Terms and Conditions.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          9. Changes to Terms
        </h2>
        <p className="mb-4 text-lg">
          Bafar Labs reserves the right to update or modify these Terms and
          Conditions at any time. Any changes will be posted on this page, and
          your continued use of the services after such changes indicates your
          acceptance of the new terms.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">10. Contact Us</h2>
        <p className="mb-4 text-lg">
          If you have any questions or concerns regarding these Terms and
          Conditions, please contact us at{" "}
          <a href="mailto:info@bafarlabs.com" className="text-blue-600">
            info@bafarlabs.com
          </a>
          .
        </p>
      </div>
    </Section>
  );
};

export default TermsAndConditions;
